// export const BASE_URL = 'http://localhost:5001/api';
// export const BASE_URL_SOCKET = 'http://localhost:5001'

export const BASE_URL_SOCKET = 'https://www.api.hub.myeasytransfer.com'
export const BASE_URL = 'https://www.api.hub.myeasytransfer.com/api'



//API End Points

export const LOGIN = '/auth/login'
export const USERINFO = '/userinfo'
export const LISTTRANSFERS = '/useractions/transfers'
export const LISTRECHARGES = '/useractions/recharges'
export const LISTINVOICES = '/useractions/invoices'
export const LISTSIMULATIONS = '/activity/simulations'
export const LISTSIMULATIONSSUPAGENT = '/superagents/simulations'
export const LISTLIVESUPAGENT = '/first-action-users'
export const ADDNOTE= '/notes'
export const GETLISTEAGENT= '/agents'
export const GETLISTESTATS= '/stats'
export const GETLISTETRANSFERTCASH= '/transfers/cash_pickup'
export const GETLISTETRANSFERTBANKACCOUNT= '/transfers/bank_account'
export const GETLISTERECHARGE= '/recharges'
export const GETLISTEINVOICE= '/invoices'
export const ASSIGNAGENT ='assign-agent'

export const CREATEBLOG ='/blogs'
export const CREATECONTENTFAQ ='/blogs'
export const CREATEIMAGEARTICLE ='/blogs'

export const GETLISTBLOGS ='/blogs/all'
export const GETALLTYPPES = '/blogs/types'
export const GETLISTGAME ='/userGiftGame/users/gifts-games'

export const NOTIFICATION ='/notifications'






